'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var privateRoute = function privateRoute(Wrapped) {
    return (0, _reactRedux.connect)()(function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

            _this.state = {
                Wrapped: Wrapped ? Wrapped : null
            };
            return _this;
        }

        _class.prototype.componentWillReceiveProps = function () {
            function componentWillReceiveProps(nextProps) {
                this.setState({
                    Wrapped: Wrapped
                });
            }

            return componentWillReceiveProps;
        }();

        _class.prototype.render = function () {
            function render() {
                var WRAPPED = this.state.Wrapped;
                return WRAPPED ? _react2.default.createElement(WRAPPED, this.props) : null;
            }

            return render;
        }();

        return _class;
    }(_react2.default.Component));
};

exports.default = privateRoute;


//////////////////
// WEBPACK FOOTER
// ./src/router/privateRoute.js
// module id = 560
// module chunks = 0